export var HandlerRole = /*#__PURE__*/function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
  return HandlerRole;
}(HandlerRole || {});

